<template>
  <!--个人中心--编辑教育-->
  <div class="ziliao">
      <div class="titleWrap">
        <p class="titleName">考试详情</p>

      </div>
      <div class="formWrapper">
        <Form :label-width="110" label-position="right" class="formMin" >
          <FormItem label="考试名称 ">
            <Input  value="项目经理证书" readonly="true" style="width: 250px;"/>
          </FormItem>
          <FormItem label="报名开始时间 ">
            <Input  value="2020-03-06" readonly="true" style="width: 250px;"/>
          </FormItem>
         <FormItem label="报名结束时间 ">
           <Input  value="2020-03-06" readonly="true" style="width: 250px;"/>
         </FormItem>
         <FormItem label="付费截止日期 ">
           <Input  value="2020-03-06" readonly="true" style="width: 250px;"/>
         </FormItem>
          <FormItem label="退考截止日期 ">
            <Input  value="2020-03-06" readonly="true" style="width: 250px;"/>
          </FormItem>
          <FormItem label="考试日期 ">
            <Input  value="2020-03-06" readonly="true" style="width: 250px;"/>
          </FormItem>
          <FormItem label="下次考试时间 ">
            <Input  value="2020-03-06" readonly="true" style="width: 250px;"/>
          </FormItem>
          <FormItem label="考试说明 ">
            <p class="desc">学员填写参加考试必要的基础资料包括：个人基本资料、学历信息、工作经历信息、培训机构信息、培训资格证信息、账号、密码，信息填写完整后需要缴费，缴费完成后提交完成考试报名，考生牢记账号（账号可以是身份证号码或手机号）密码，凭账号密码参加考试（单点登录）；考生填写信息过程中系统将自动判断考生填写的信息与报考条件是否匹配。</p>
          </FormItem>
        </Form>
        <div class="keepThis">
            <router-link  to="/ziliao/kaoshiziliao" class="keepBtn">我的资料</router-link>
            <span class="keepBtn" @click="apply">申请发票</span>
            <router-link to="/" class=" start">开始考试</router-link>
        </div>
      </div>

  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
  .keepBtn ,.start{
    display: inline-block;
    width: 140px;
    height: 52px;
    background-color: #957960;
    text-align: center;
    line-height: 50px;
    color: #fff;
    font-size: 18px;
    margin-right: 25px;
    border-radius: 5px;
  }
  .start{
    color: #806853;
    border:1px solid #806853;
    background-color: #fff;
  }
  .keepBtn:hover {
    background-color: #957960;
    cursor: pointer;
  }
  .titleWrap {
    height: 40px;
    font-size: 20px;
    padding-bottom: 20px;
    color: #333;
    text-align: justify-all;
    border-bottom: 1px solid #E1E1E1;
    margin-bottom: 30px;
    .titleName {
      float: left;
      line-height: 24px;
    }

  }
  .desc{
    font-size: 14px;
    color: #666;
    margin-top: 5px;
  }


  .keepThis {
    padding: 10px 0 0 80px;
  }
  .layoutSide {
    position: relative;
  }
</style>
<script type="text/ecmascript-6">
    export default {
        name: '',
        props: {},
        data() {
            return {
              formValidate:{
                radio:'yes'
              }
            };
        },
        methods: {
          apply(){
            this.$router.push({
              name:'applyfapiao',
              query:{
                invoiceBody:'我的考试',
                invoiceAmount:180,
                orderId:1
            }
            })
          },
        },
        created() {

        },
        components: {
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/center/mykaoshi.vue